module.exports = __webpack_public_path__ + "img/buddy_antenna-06.ad0d3cc6.svg";